import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Api_Instance from "../../api/Api_Instance";
import { forgetpassword } from "../../api/endpoints";
import { useDispatch } from "react-redux";
import { setForgetPassword } from "../../redux/slice/Slice";
import Loader from "../../common/loader/Loader";
import { IoIosEyeOff, IoMdEye } from "react-icons/io";
import { RiLock2Line } from "react-icons/ri";

function Confirmpassword({ logindata }) {
    const [isLogin, setIsLogin] = useState(true);
    const [showPassword, setShowPassword] = useState({
        password: false,
        confirm_password: false,
    });
    const [loading, setLoading] = useState(false);
    const [login, setLogin] = useState({
        password: "",
        confirm_password: "",
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const api = Api_Instance.unAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;

        setLogin((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        const fieldError = validateField(name, value);
        setErrors((prevState) => ({
            ...prevState,
            [name]: fieldError,
        }));
    };

    const validateField = (name, value) => {
        switch (name) {
            case "password":
                if (!value) return "Password is required";
                if (value.length < 8) return "Password must be at least 8 characters long";
                break;
            case "confirm_password":
                if (!value) return "Confirm password is required";
                if (value !== login.password) return "Passwords do not match";
                break;
            default:
                return "";
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const validationErrors = validate(login);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            await api("POST", `${forgetpassword?.CONFIRM_PASSWORD}?email=${logindata?.email}`, {
                password: login.password,
                confirm_password: login.confirm_password,
            });

            dispatch(setForgetPassword({
                email: false,
                otp: false,
                confirmpassword: false,
            }));
        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setLoading(false);
        }
    };

    const validate = (values) => {
        const error = {};
        if (!values.password) {
            error.password = "Password is required";
        } else if (values.password.length < 8) {
            error.password = "Password must be at least 8 characters long";
        }

        if (!values.confirm_password) {
            error.confirm_password = "Confirm password is required";
        } else if (values.confirm_password !== values.password) {
            error.confirm_password = "Passwords do not match";
        }

        return error;
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm xl:px-5 lg:px-5 md:px-5 px-5">
            <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <button
                    onClick={() =>
                        dispatch(setForgetPassword({
                            email: false,
                            otp: false,
                            confirmpassword: false,
                        }))
                    }
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                >
                    <FontAwesomeIcon icon={faTimes} size="lg" />
                </button>
                <div className="flex justify-center mb-[55px]">
                    <div className="text-center mx-4 cursor-pointer">
                        <h2 className={`text-xl font-medium mb-2 ${isLogin ? "text-text_color" : ""}`}>
                            Enter New Password
                        </h2>
                        <p className="text-[#B3B3B3] text-[16px] mt-2">
                            Enter your new password
                        </p>
                    </div>
                </div>
                <form className="max-w-md mx-auto" onSubmit={handleSubmit}>
                    <div className="relative">
                        <label className="block text-gray-700 text-sm font-bold mb-2 text-white" htmlFor="password">
                            <RiLock2Line className="absolute left-3 top-[35px] text-gray-500 text-[24px]" />
                            Password
                        </label>
                        <input
                            className="appearance-none border rounded w-full py-2 pl-12 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="password"
                            type={showPassword.password ? "text" : "password"}
                            name="password"
                            value={login.password}
                            placeholder="Enter your password"
                            onChange={handleChange}
                        />
                        <div
                            className="absolute right-[10px] text-[20px] top-[57%] cursor-pointer"
                            onClick={() => togglePasswordVisibility("password")}
                        >
                            {showPassword.password ? <IoMdEye /> : <IoIosEyeOff />}
                        </div>
                        {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
                    </div>
                    <div className="mb-[50px] relative">
                        <label className="block text-gray-700 text-sm font-bold mb-2 text-white" htmlFor="confirm_password">
                            <RiLock2Line className="absolute left-3 top-[35px] text-gray-500 text-[24px]" />
                            Confirm Password
                        </label>
                        <input
                            className="appearance-none border rounded w-full py-2 pl-12 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="confirm_password"
                            type={showPassword.confirm_password ? "text" : "password"}
                            name="confirm_password"
                            value={login.confirm_password}
                            placeholder="Enter your confirm password"
                            onChange={handleChange}
                        />
                        <div
                            className="absolute right-[10px] text-[20px] top-[57%] cursor-pointer"
                            onClick={() => togglePasswordVisibility("confirm_password")}
                        >
                            {showPassword.confirm_password ? <IoMdEye /> : <IoIosEyeOff />}
                        </div>
                        {errors.confirm_password && <p className="text-red-500 text-sm">{errors.confirm_password}</p>}
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            className="bg-primaryColor text-white w-full font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center [transition:all_.15s_ease-in-out]"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? <Loader /> : "Continue"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Confirmpassword;
